import { Button, Grid } from '@mui/material'
import React, { useEffect, useState } from 'react'
import CustomList from './CustomList'

const HidingSetting = ({ columns, hiddenColumns = [], setHiddenColumns, isActivity = false }) => {
  const [left, setLeft] = useState([])
  const [right, setRight] = useState([])
  const [checkedLeft, setCheckedLeft] = useState([])
  const [checkedRight, setCheckedRight] = useState([])

  useEffect(() => {
    let leftItems = []
    let rightItems = []
    columns?.forEach((it) => {
      if (hiddenColumns?.includes(+it.path?.split('__')[0])) {
        rightItems.push(it)
      } else {
        leftItems.push(it)
      }
    })
    setLeft(leftItems)
    setRight(rightItems)
  }, [columns, hiddenColumns])

  const moveToRight = () => {
    const updatedArrayIds = new Set([
      ...hiddenColumns,
      ...checkedLeft.map((it) => +it.path.split('__')[0]),
    ])
    setHiddenColumns(Array.from(updatedArrayIds))
    setCheckedLeft([])
  }

  const moveToLeft = () => {
    const checkedIds = checkedRight.map((it) => +it.path.split('__')[0])
    const updatedHiddenColumns = hiddenColumns.filter((it) => !checkedIds?.includes(it))
    setHiddenColumns(updatedHiddenColumns)
    setCheckedRight([])
  }

  return (
    <Grid className="mb-3" container gap={2} justifyContent="center" alignItems="center">
      <Grid item>
        <CustomList
          title={isActivity ? 'Visible activity' : 'Visible columns'}
          items={left}
          setChecked={setCheckedLeft}
          checked={checkedLeft}
        />
      </Grid>
      <Grid item>
        <Grid container direction="column" alignItems="center">
          <Button
            sx={{ my: 0.5 }}
            variant="outlined"
            color="primary"
            size="small"
            onClick={moveToRight}
            disabled={checkedLeft.length === 0}
            aria-label="move selected right"
          >
            &gt;
          </Button>
          <Button
            sx={{ my: 0.5 }}
            variant="outlined"
            size="small"
            color="primary"
            onClick={moveToLeft}
            disabled={checkedRight.length === 0}
            aria-label="move selected left"
          >
            &lt;
          </Button>
        </Grid>
      </Grid>
      <Grid item>
        <CustomList
          title={isActivity ? 'Hidden activity' : 'Hidden columns'}
          items={right}
          setChecked={setCheckedRight}
          checked={checkedRight}
        />
      </Grid>
    </Grid>
  )
}

export default HidingSetting
